const initialState = {
    hospitalPermissionsView:{},
    hospitalListsView: [],
    hospitalStatusView: [],
    changedHospitalStatusView : [],
    addHospitalResponseView : [],
    loadingHospitalView: false,
    isDisabledView: true,
    hospitalBasicInfoView : [],
    hospitalDetailsView : [],
    accountDetailsView : [],
    errorsHospitalView: {},
    errorsRegistrationView: {},
    errorsOldDataView: {},
    errorsTpaView: {},
    errorsRmoView: {},
    errorsNursingView: {},
    hospitalIdView :'',
    alertDataView:[],
    grievanceDataView:[],
    hospitalOldDetailView:[],
    hospitalProfileView:[],
    registrationDetailsView : [],
    tpaStaffsView:[],
    rmoStaffsView:[],
    ownerStaffView:[],
    ownerStaffsView:[],
    nursingStaffsView:[],
    isCashlessAvailableView:"",
    hospitalInsuranceCompaniesView:[],
    rohiniDetailView:[],
    messageView:"",
}

const  hospitalReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HOSPITALLIST_PENDING_VIEW":
        case "GET_HOSPITAL_DETAIL_PENDING_VIEW":
        case "UPDATE_HOSPITAL_PENDING_VIEW":
        case "UPDATE_HOSPITAL_STATUS_PENDING_VIEW":
        case "DELETE_HOSPITAL_PENDING_VIEW":
        case "GET_HOSPITALLISTBYID_PENDING_VIEW":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_PENDING_VIEW":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_PENDING_VIEW":
        case "GET_HOSPITAL_REGISTRATION_DETAILS_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_PENDING_VIEW":
        case "ADD_HOSPITAL_STAFF_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_PENDING_VIEW":
        case "ADD_UPDATE_ROHINI_DETAILS_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_PROFILE_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_ALERT_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_PENDING_VIEW":
        case "ADD_UPDATE_HOSPITAL_TPA_PENDING_VIEW":
        case "DELETE_HOSPITAL_STAFF_PENDING_VIEW":
        case "DELETE_HOSPITAL_REGISTRATION_PENDING_VIEW":
            return { 
                ...state, 
                loadingHospitalView: true,
                messageView:""
             };
        case "SET_MESSAGE_VIEW":
            return { ...state,
                messageView:action.payload 
            };
        case "SHOW_HOSPITAL_OTHER_FORMS_PENDING_VIEW":
            return { 
                ...state, 
                loadingHospitalView: true,
                isDisabledView: true,
                addHospitalResponseView:[],
                errorsRegistrationView:{},
                messageView:"",
                hospitalBasicInfoView : [],
                hospitalDetailsView : [],
                accountDetailsView : [],
                errorsHospitalView:{},
                errorsOldDataView:{},
                errorsTpaView:{},
                errorsRmoView:{},
                errorsNursingView:{},
                hospitalIdView :'',
                alertDataView:[],
                grievanceDataView:[],
                hospitalOldDetailView:[],
                hospitalProfileView:[],
                registrationDetailsView : [],
                tpaStaffsView:[],
                rmoStaffsView:[],
                ownerStaffView:[],
                ownerStaffsView:[],
                nursingStaffsView:[],
                isCashlessAvailableView:"",
                hospitalInsuranceCompaniesView:[],
                rohiniDetailView:[],
             };
        case "SHOW_HOSPITAL_OTHER_FORMS_FULFILLED_VIEW":
            return { 
                ...state, 
                isDisabledView: false,
                hospitalIdView:action.payload,
                messageView:""
             };

        case "GET_HOSPITALLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                hospitalListsView: action.payload,
                hospitalCountView: action.count,
                hospitalPermissionsView:action.permissions,
            };

        case "ADD_HOSPITAL_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                addHospitalResponseView: action.payload,
                isDisabledView:false,
                hospitalIdView: action.payload?.data?.id,
                messageView:action.payload?.message,
            };

        case "UPDATE_HOSPITAL_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                changedHospitalStatusView: action.payload,
                messageView:action.payload?.message,
            };

        case "GET_HOSPITAL_DETAIL_FULFILLED_VIEW":
            const data = action.payload;
            return {
                ...state,
                loadingHospitalView: false,
                hospitalDetailsView: data,
                accountDetailsView:data?.accountDetail,
                alertDataView:data?.alert,
                grievanceDataView:data?.grievance,
                hospitalOldDetailView:data?.oldDetail,
                hospitalProfileView:data?.profile,
                registrationDetailsView:data?.registrationDetail,
                tpaStaffsView:data?.tpaStaffs,
                rmoStaffsView:data?.rmoStaff,
                ownerStaffView:data?.ownerStaff,
                ownerStaffsView: Array.isArray(data?.ownerStaffs) ? data.ownerStaffs : [],
                nursingStaffsView:data?.nursingStaff,
                hospitalInsuranceCompaniesView:data?.hospitalInsuranceCompanies,
                isCashlessAvailableView:data?.is_cashless_facility,
                rohiniDetailView:data?.rohiniDetail,
            };

        case "UPDATE_HOSPITAL_STATUS_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                changedHospitalStatusView: action.payload,
            };

        case "GET_HOSPITALLISTBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                hospitalBasicInfoView: action.payload
            };

        case "DELETE_HOSPITAL_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                changedHospitalStatusView: action.payload
            };

        case "RESET_DELETE_HOSPITALS_STATUS_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                changedHospitalStatusView: [],
                errorsHospitalView:{}
            };

        case "GET_HOSPITAL_ACCOUNT_DETAIL_FULFILLED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                hospitalBasicInfoView: action.payload.data
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsRegistrationView:{},
                messageView:action.payload?.message,
                hospitalBasicInfoView:action.payload?.data,
            };
        case "ADD_HOSPITAL_STAFF_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_HOSPITAL_CASHLESS_STATUS_FULFILLED_VIEW":
            const hospital = action.payload?.hospital;
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                // isCashlessAvailable:hospital?.is_cashless_facility,
                // hospitalInsuranceCompanies:action.payload?.hospital_insurance_companies,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_ROHINI_DETAILS_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload.message,
            };
        case "ADD_UPDATE_HOSPITAL_PROFILE_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_ALERT_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsHospitalView:{},
                //hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsOldDataView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_TPA_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsTpaView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_RMO_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsRmoView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsNursingView:{},
                hospitalBasicInfoView:action.payload?.data,
                messageView:action.payload?.message,
            };
        case "DELETE_HOSPITAL_STAFF_FULFILLED_VIEW":
            return { 
                ...state, 
                loadingHospitalView: false,
                errorsNursingView:{},
                messageView:action.payload?.message,
            };

        case "GET_HOSPITALLIST_REJECTED_VIEW":
        case "ADD_HOSPITAL_REJECTED_VIEW":
        case "GET_HOSPITAL_DETAIL_REJECTED_VIEW":
        case "UPDATE_HOSPITAL_REJECTED_VIEW":
        case "UPDATE_HOSPITAL_STATUS_REJECTED_VIEW":
        case "DELETE_HOSPITAL_REJECTED_VIEW":
        case "GET_HOSPITALLISTBYID_REJECTED_VIEW":
        case "GET_HOSPITAL_ACCOUNT_DETAIL_REJECTED_VIEW":
        case "ADD_HOSPITAL_REGISTRATION_DETAILS_REJECTED_VIEW":
        case "ADD_HOSPITAL_STAFF_REJECTED_VIEW":
        case "ADD_UPDATE_HOSPITAL_ACCOUNT_REJECTED_VIEW":
        case "ADD_HOSPITAL_CASHLESS_STATUS_REJECTED_VIEW":
        case "ADD_UPDATE_ROHINI_DETAILS_REJECTED_VIEW":
        case "ADD_UPDATE_HOSPITAL_PROFILE_REJECTED_VIEW":
        case "ADD_UPDATE_HOSPITAL_ALERT_REJECTED_VIEW":
        case "ADD_UPDATE_HOSPITAL_GRIEVANCE_REJECTED_VIEW":
        case "DELETE_HOSPITAL_STAFF_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload
            };
        // Delete ke success/fail message component toast me dikhata hai - delete ke turant baad
        // Hospital/{id} refetch ka PENDING message clear kar deta hai, isliye yahan message/errors set nahi karte
        case "DELETE_HOSPITAL_REGISTRATION_FULFILLED_VIEW":
        case "DELETE_HOSPITAL_REGISTRATION_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
            };
        case "ADD_UPDATE_HOSPITAL_REGISTRATION_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_OLD_DATA_REJECTED_VIEW":
            console.log(action.payload,action.payload)
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload
            };
        case "ADD_UPDATE_HOSPITAL_TPA_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_RMO_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload?.data
            };
        case "ADD_UPDATE_HOSPITAL_NURSING_REJECTED_VIEW":
            return {
                ...state,
                loadingHospitalView: false,
                errorsHospitalView: action.payload?.data
            };

        default:
            return state;
    }
}

export default hospitalReducerView;